import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class BspService {
    constructor(private datatask: DataTaskService) {}

    public async getEdit(bspKeyno: string): Promise<BspEdit> {
        return (await this.datatask.Post(3156, { bsp_keyno: bspKeyno }))[0];
    }

    public async save(edit: BspEdit): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3158, edit))[0];
    }

    public async getMenu(bspKeyno: string): Promise<BspMenuGet> {
        return (await this.datatask.Post(3157, { bsp_keyno: bspKeyno }))[0];
    }

    public async listRecordRights(): Promise<BspRecordRight[]> {
        return this.datatask.Post(88);
    }

    public async copy(menu: BspMenuGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3609, menu))[0];
    }

    public async loadUsergroups(bspKeyno: string): Promise<Record<string, unknown>[]> {
        return this.datatask.Post(3162, { bsp_keyno: bspKeyno });
    }

    public async loadSubscriptions(bspKeyno: string): Promise<Record<string, unknown>[]> {
        return this.datatask.Post(3163, { bsp_keyno: bspKeyno });
    }

    public async loadSubscriptionSettings(subscriptionKeyno: string): Promise<Record<string, unknown>[]> {
        return this.datatask.Post(3164, { bspugsub_keyno: subscriptionKeyno });
    }

    public async loadTabs(bspKeyno: string): Promise<Record<string, unknown>[]> {
        return this.datatask.Post(3165, { bsp_keyno: bspKeyno });
    }

    public async loadDocuments(bspKeyno: string): Promise<Record<string, unknown>[]> {
        return this.datatask.Post(3166, { bsp_keyno: bspKeyno });
    }

    public async getUsergroup(bspKeyno: string, bspugKeyno: string): Promise<BspUsergroupEdit> {
        return (await this.datatask.Post(3159, { bsp_keyno: bspKeyno, bspug_keyno: bspugKeyno }))[0];
    }

    public async saveUsergroup(edit: BspUsergroupEdit): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3160, edit))[0];
    }

    public async getSubscription(subscriptionKeyno: string): Promise<BspSubscriptionEdit> {
        return (await this.datatask.Post(3167, { bspsub_keyno: subscriptionKeyno }))[0];
    }

    public async saveSubscription(edit: BspSubscriptionEdit): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3168, edit))[0];
    }

    public async getSetup(): Promise<BspSetupEdit> {
        return (await this.datatask.Post(3334))[0];
    }

    public async listBsps(): Promise<BspListItem[]> {
        return this.datatask.Post(3333);
    }

    public async executeSetup(edit: BspSetupEdit): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3335, edit))[0];
    }

    public async rollbackSetup(edit: BspSetupEdit): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3336, edit))[0];
    }

    public async resetUsergroups(): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3584))[0];
    }

    public async nullData(): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3585))[0];
    }

    public async resetTransactionData(edit: BspSetupEdit): Promise<ErrorMessageResponse | undefined> {
        return (await this.datatask.Post(3893, edit))[0];
    }
}

export interface BspEdit {
    bsp_keyno: string;
    bsp_name: string;
    reg_by_user: string;
    reg_datetime: string;
}

export interface BspMenuGet {
    bsp_keyno: string;
    bsp_name: string;
    reg_by_user: string;
    reg_datetime: string;
    word_id: string;
    bg_bspmenu_main: string;
    html_description_base64: string;
    recordright_no: string;
}

export interface BspUsergroupEdit {
    bsp_keyno: string;
    bspug_keyno: string;
    bsp_name: string;
    bspug_name: string;
    reg_by_user: string;
    reg_datetime: string;
    word_id: string;
}

export interface BspSubscriptionEdit {
    bspsub_keyno: string;
    bsp_name: string;
    subscription_name: string;
    usergroup_names: string;
    html_description_base64: string;
    equal_html_description_for_all: string;
}

export interface BspSetupEdit {
    bsp_keyno: string;
    bsp_keyno_today: string;
    infotext: string;
    show_execute_setup: string;
    show_rollback_setup: string;
    show_bspsetup_reset_usergroups: string;
    show_bspsetup_nulldata: string;
    show_bspsetup_nulldata_transactiondata: string;
}

export interface BspListItem {
    bsp_keyno: string;
    bsp_name: string;
}

export interface BspRecordRight {
    item_id: string;
    item_name: string;
}
